import { TApiResponse, TPager, } from "@/types";

import http from "@/http";




export async function createComplaints(input: any) {
    const response = await http.post<TApiResponse<null>>(
        "/complaints", input
    )
    return response.data
}

export async function getComplaints(
    search?: string, 
    pager?: TPager, 
    filter?: Record<string, any>
) {
    const response = await http.get<TApiResponse<any>>("/complaints", {
        params: {
            "search": search,
            ...pager,
            ...filter
        }
    })
    return response.data
}

export async function getComplaint(id: string) {
    const response = await http.get<TApiResponse<any>>(`/complaints/${id}`)
    return response.data
}
